import { connect } from 'react-redux'

import { doFetchGitHubInstalls } from 'ducks/integrations/github'

import LinkGitHubCardsView from './view'

export default connect(null, { doFetchGitHubInstalls })(LinkGitHubCardsView)
